import { useQuery } from '@tanstack/react-query';
import { signupStatusSchema, type SignupStatus } from '@castinflow/shared';
import { apiFetch } from './api';

/**
 * Kayıt kapısının durumu (M7 T1, K-M7-02): arayüz durumu SUNUCUDAN öğrenir (`GET /signup/status`; sır içermez). Derleme
 * zamanında bilinmez: aynı web derlemesi kapalı (staging/üretim) ve açık (geliştirme/e2e) süreçlerle çalışır.
 *
 * Arayüz güvenlik sınırı değildir — kapalıyken `POST /signup` API'de reddedilir. Bu sorgu yalnız kayıt bağlantısının
 * gösterilmesini ve kayıt sayfasının dürüst "kayıt kapalı" durumunu belirler. Durum okunamadıysa bağlantı gösterilmez.
 */
export const SIGNUP_STATUS_QUERY_KEY = ['signup-status'] as const;

export function useSignupStatus() {
  return useQuery({
    queryKey: SIGNUP_STATUS_QUERY_KEY,
    queryFn: async (): Promise<SignupStatus> =>
      signupStatusSchema.parse(await apiFetch<unknown>('/signup/status')),
    staleTime: 60_000,
    retry: 1,
  });
}
